import { render, staticRenderFns } from "./SwitchTabSearch.vue?vue&type=template&id=c3e5b16a&scoped=true&"
import script from "./SwitchTabSearch.vue?vue&type=script&lang=js&"
export * from "./SwitchTabSearch.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTabSearch.vue?vue&type=style&index=0&id=c3e5b16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e5b16a",
  null
  
)

export default component.exports